import axios from "axios";
import { ENDPOINTS } from "../../apiConfig";
// import { showToast } from "../../../components";
import axiosRequest from "./axiosService";

///
///https://kw-workforce.s3.ap-south-2.amazonaws.com/tektree llc/employees/1/work authorization/04_2025/Notepad_1745911567228.txt
///

//export const uploadFiles = async ({ path, coll, bulkUpload, doc }) => {
// export const uploadFiles = async ({
//   uploadType = "single",
//   field = "doc",
//   uiid,
//   entity,
//   category,
//   coll,
//   doc,
// }) => {
//   try {
//     const token = localStorage.getItem("token");

//     const formData = new FormData();
//     Object.entries({
//       coll,
//       ...(uploadType === "single" && { doc }),
//       uiid,
//       entity,
//       category,
//     }).forEach(([key, value]) => {
//       if (value !== undefined && value !== null) {
//         formData.append(key, value);
//       }
//     });

//     if (uploadType === "multiple") {
//       doc.forEach((file) => {
//         formData.append(field, file);
//         formData.append("fileIds", file.id);
//       });
//     }

//     const response = await axios.post(
//       //`${ENDPOINTS.UNIVERSAL.UPLOAD_FILE}/${path}/upload?bulkUpload=${bulkUpload}`,
//       `${ENDPOINTS.UNIVERSAL.UPLOAD_FILE}/${String(
//         coll
//       ).toLowerCase()}s/upload?uploadType=${uploadType}&field=${field}`,
//       formData,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//         withCredentials: true,
//       }
//     );
//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//   }
// };

export const uploadFiles = async ({
  uploadType = "single",
  field = "doc",
  uiid,
  entity,
  category,
  coll,
  doc,
  fileIds,
  workforce_upload = false
}) => {
  const formData = new FormData();

  Object.entries({
    coll,
    uiid,
    entity,
    category,
    ...(fileIds ? { fileIds } : {}),
  }).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  // Append file last to ensure text fields are parsed first (best practice for some parsers)
  if (uploadType === "single" && doc) {
    formData.append(field, doc);
  }
  if (uploadType === "multiple" && Array.isArray(doc)) {
    doc.forEach((file) => {
      formData.append(field, file);
      if (file.id) {
        formData.append("fileIds", file.id);
      }
    });
  }



  if (workforce_upload!=undefined && workforce_upload==true) {
    console.log("ats====>", workforce_upload)
    return await axiosRequest({
      method: "POST",
      url: `${ENDPOINTS.ATS_UNIVERSAL.UPLOAD_FILE}/${String(
        coll,
      ).toLowerCase()}s/upload`,
      params: {
        uploadType,
        field,
        workforce_upload
      },
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.UNIVERSAL.UPLOAD_FILE}/${String(
      coll,
    ).toLowerCase()}s/upload`,
    params: {
      uploadType,
      field,
    },
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getPresignedUrl = async (fileKey) => {
  try {
    const res = await axios.get(
      `${ENDPOINTS.UNIVERSAL.GET_S3_LINK}&key=${fileKey}`,
      { withCredentials: true }
    );
    return res.data.data;
  } catch (err) {
    return "";
  } finally {
  }
};

export const deleteFile = async ({ coll, key }) => {
  console.log("deleteFile invoked:", { coll, key });
  return await axiosRequest({
    method: "DELETE",
    url: `${ENDPOINTS.UNIVERSAL.UPLOAD_FILE}/${String(
      coll,
    ).toLowerCase()}s/deleteBucketFile`,
    params: {
      coll,
      key,
    },
    data: {
      coll,
      key,
    },
  });
};

// export const uploadFiles = async ({ path, coll, bulkUpload, doc }) => {
//   try {
//     const token = localStorage.getItem("token");

//     // console.log("path", path);
//     // console.log("coll", coll);
//     // console.log("bulkUpload", bulkUpload);
//     // console.log("payload", payload);

//     const formData = new FormData();
//     formData.append("coll", coll);
//     formData.append("doc", doc);

//     const response = await axios.post(
//       `${ENDPOINTS.UNIVERSAL.UPLOAD_FILE}/${path}/upload?bulkUpload=${bulkUpload}`,
//       formData,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "multipart/form-data",
//         },
//         withCredentials: true,
//       }
//     );
//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//   }
// };

//
//
//
// export const uploadFiles = async ({ coll, bulkUpload, payload }) => {
//   try {
//     const token = localStorage.getItem("token");

//     console.log("coll", coll);
//     console.log("bulkUpload", bulkUpload);
//     console.log("payload", payload);
//   } catch (error) {
//     console.error("API Error:", error.response || error);
//   }

//   // try {
//   //   const token = localStorage.getItem("token");

//   //   console.log("coll", coll);
//   //   console.log("bulkUpload", bulkUpload);
//   //   console.log("payload", payload);

//   //   // const response = await axios.post(
//   //   //   `${ENDPOINTS.UNIVERSAL.UPLOAD_FILE}?coll=${coll}/upload&bulkUpload=${bulkUpload}`,
//   //   //   { payload: payload },
//   //   //   {
//   //   //     headers: {
//   //   //       Authorization: `Bearer ${token}`,
//   //   //       "Content-Type": "application/json",
//   //   //     },
//   //   //     withCredentials: true,
//   //   //   }
//   //   // );
//   //   // return {
//   //   //   success: true,
//   //   //   data: response.data,
//   //   // };
//   // } catch (error) {
//   //   console.error("API Error:", error.response || error);
//   // }
// };
